<template>
  <article class="rh-card" @click="emit('book', item)">
    <div class="rh-card-photo">
      <div
        class="rh-card-photo-img"
        :style="
          item.photo ? { backgroundImage: cssUrl(item.photo) } : undefined
        "
      />
      <span v-if="!item.photo" class="rh-card-photo-empty">Нет фото</span>
    </div>

    <div class="rh-card-body">
      <h3 class="rh-card-title">{{ item.address || item.title }}</h3>

      <p v-if="metaParts.length" class="rh-card-meta">
        <template v-for="(part, i) in metaParts" :key="i">
          <span v-if="i > 0" class="rh-card-meta-dot" aria-hidden="true" />
          <span class="rh-card-meta-item">{{ part }}</span>
        </template>
      </p>

      <div class="rh-card-footer">
        <div class="rh-card-price">
          <span class="rh-card-price-amount">{{
            formatPrice(item.pricePerDay)
          }}</span>
          <span class="rh-card-price-suffix">за сутки</span>
        </div>
        <button type="button" class="rh-card-cta">Забронировать</button>
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { cssUrl } from '../css-url';
import type { WidgetAccommodation } from '../types';

const props = defineProps<{ item: WidgetAccommodation }>();

const emit = defineEmits<{
  book: [item: WidgetAccommodation];
}>();

const metaParts = computed<string[]>(() => {
  const out: string[] = [];
  if (props.item.rooms && props.item.rooms > 0) {
    out.push(
      `${props.item.rooms} ${pluralRu(props.item.rooms, ['комната', 'комнаты', 'комнат'])}`,
    );
  }
  if (props.item.beds && props.item.beds > 0) {
    out.push(
      `${props.item.beds} ${pluralRu(props.item.beds, ['спальное место', 'спальных места', 'спальных мест'])}`,
    );
  }
  if (props.item.area && props.item.area > 0) {
    out.push(`${Math.round(props.item.area)} м²`);
  }
  return out;
});

function pluralRu(n: number, forms: [string, string, string]): string {
  const abs = Math.abs(n) % 100;
  const last = abs % 10;
  if (abs > 10 && abs < 20) return forms[2];
  if (last > 1 && last < 5) return forms[1];
  if (last === 1) return forms[0];
  return forms[2];
}

function formatPrice(value: number): string {
  if (!value) return '—';
  try {
    return new Intl.NumberFormat('ru-RU', {
      style: 'currency',
      currency: props.item.currency || 'RUB',
      maximumFractionDigits: 0,
    }).format(value);
  } catch {
    return `${Math.round(value)} ${props.item.currency}`;
  }
}
</script>
